module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('NbEditor', {
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.content) + "\n\t\t")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "alert alert-info"
  }, [_c('h1', [_vm._v("Powered by UEditor.")]), _vm._v(" "), _c('p', [_vm._v("说明：给普通用户填写的内容时，我们使用NbEditor，NbEditor功能较为简单，但是能够满足大多数文字排版功能。")]), _vm._v(" "), _c('p', [_vm._v("当我们给管理员使用的时候，用NbEditor，用NbEditor功能更为强大！")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-cfdbc7c4"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/backyard/view/wheel/NbUEditorDemo.vue
// module id = 1026
// module chunks = 1